import { z } from 'zod/v4';

export interface ICityListRequest {
  countryCode: string;
  postCode: string;
  city?: string;
}

export interface ICity {
  city: string;
  postcode: string; //fix the spelling of this to postCode???
}

export const CITY_SCHEMA: z.ZodType<ICity> = z.object({
  city: z.string(),
  postcode: z.string(),
});

export const CITIES_SCHEMA: z.ZodType<ICity[]> = z.array(CITY_SCHEMA);
